var Emitter = require('tiny-emitter');
var emitter = new Emitter();
export default emitter;